var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "flex-shrink-0",
    viewBox: "0 0 54 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 63.5H22.5C21.3 63.5 20.16 63.02 19.32 62.18C18.48 61.34 18 60.2 18 59V52.25H22.5V59H49.5V5H22.5V11.75H18V5C18 3.8 18.48 2.66 19.32 1.82C20.16 0.98 21.3 0.5 22.5 0.5H49.5C50.7 0.5 51.84 0.98 52.68 1.82C53.52 2.66 54 3.8 54 5V59C54 60.2 53.52 61.34 52.68 62.18C51.84 63.02 50.7 63.5 49.5 63.5Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.82 42.32L31.86 34.25H0V29.75H31.89L23.85 21.68L27.03 18.5L40.53 32L27.03 45.5L23.85 42.32H23.82Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccess);
export default __webpack_public_path__ + "static/media/ic-access.1862f0997da7f76226ff0a558b4ecf65.svg";
export { ForwardRef as ReactComponent };